module.exports = __webpack_public_path__ + "img/cszq_banner_3.79f7e3ac.png";